import React from 'react';
import { ListItem, Typography, IconButton, Collapse, List } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { HistoryListItem } from '../History';
import { projectStyles } from '../../styles/drawerStyles';

/**
 * 개별 프로젝트 아이템 컴포넌트
 * @param {object} props - 컴포넌트 props
 * @returns {JSX.Element} - 프로젝트 아이템
 */
const ProjectListItem = ({
  project,
  idx,
  projectHistories,
  isOpen,
  onToggle,
  onMenuClick,
  // HistoryListItem props
  selectedHistoryId,
  setDrawerOpen,
  setHistoryMenuAnchor,
  setHistoryMenuIdx,
  projectSubMenuRefs,
  historyMenuRefs,
  projects,
  handleAddHistoryToProject,
  handleEditHistory,
  handleDeleteClick,
  menuOpenIdx,
  setMenuOpenIdx,
  setHistory,
  setAnalyzedVideoId,
  setAnalyzedTitle,
  setAnalyzedUrl
}) => {
  return (
    <React.Fragment>
      <ListItem sx={projectStyles.listItem} onClick={onToggle}>
        {isOpen ? 
          <FolderOpenIcon sx={{ color: '#1976d2' }} /> : 
          <FolderIcon sx={{ color: '#666' }} />
        }
        <Typography sx={projectStyles.projectName}>
          {project.name}
        </Typography>
        <Typography sx={projectStyles.projectCount}>
          {projectHistories.length}
        </Typography>
        <IconButton
          size="small"
          sx={projectStyles.moreButton}
          onClick={(e) => {
            e.stopPropagation();
            onMenuClick(e, idx);
          }}
        >
          <MoreHorizIcon fontSize="small" />
        </IconButton>
      </ListItem>
      <Collapse in={isOpen}>
        <List sx={{ pl: 3, py: 0 }}>
          {projectHistories.map((item, itemIdx) => (
            <HistoryListItem
              key={item.id}
              item={item}
              idx={itemIdx}
              selected={selectedHistoryId === item.id}
              onSelect={() => {
                setDrawerOpen(false);
              }}
              onMoreClick={(e) => {
                e.stopPropagation();
                setHistoryMenuAnchor(item.id);
                setHistoryMenuIdx(itemIdx);
              }}
              refFn={el => {
                if (item.id) {
                  projectSubMenuRefs.current[item.id] = el;
                  historyMenuRefs.current[item.id] = el;
                }
              }}
              projects={projects}
              handleAddHistoryToProject={handleAddHistoryToProject}
              handleEditHistory={handleEditHistory}
              handleDeleteClick={handleDeleteClick}
              menuOpenIdx={menuOpenIdx}
              setMenuOpenIdx={setMenuOpenIdx}
              listIdx={itemIdx}
              setHistory={setHistory}
              setAnalyzedVideoId={setAnalyzedVideoId}
              setAnalyzedTitle={setAnalyzedTitle}
              setAnalyzedUrl={setAnalyzedUrl}
              setDrawerOpen={setDrawerOpen}
            />
          ))}
        </List>
      </Collapse>
    </React.Fragment>
  );
};

export default ProjectListItem; 